export default __webpack_public_path__ + "static/media/Hammer of Solemn Vows.136d5750.jpg";